import { auth } from "../../configs/FirebaseConfig";
import axios from "axios";
import urls from "../../urls";

export const getFirebaseIDToken = () => {
  return new Promise((resolve, reject) => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      currentUser
        .getIdToken(true)
        .then((idToken) => resolve(idToken))
        .catch((error) => reject(error));
    } else {
      reject(new Error("No authenticated user"));
    }
  });
};

export const changeUserPassword = (object, token) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };

    axios
      .post(urls.changeUserPassword, object, config)
      .then((result) => {
        resolve(result);
      })
      .catch((err) => reject(err));
  });
};

export const deleteUser = async (userId) => {
  try {
    const token = await getFirebaseIDToken();

    const response = await axios.delete(`${urls.deleteUser}/${userId}`, {
      headers: {
        Authorization: token,
      },
    });

    return response;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};
